import React, { useEffect, useState } from "react";
import { FaEdit, FaEye, FaTrashAlt } from "react-icons/fa";
import useEscClose from "../../useEscClose";
import FiltroDescuento from "./FiltroDescuento";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import CrearDescuentoFlota from "./CrearDescuentoFlota";
import VerDescuentoFlota from "./VerDescuentoFlota";
import EditarDescuentoFlota from "./EditarDescuentoFlota";
import EliminarDescuentoFlota from "./EliminarDescuentoFlota";

const DEFAULT_PAGE_SIZE = 30;

export default function ListaDescuento() {
  // ============================
  //        LISTADO
  // ============================
  const [items, setItems] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [porPagina, setPorPagina] = useState(DEFAULT_PAGE_SIZE);
  const [totalBackend, setTotalBackend] = useState(0);
  const [cargando, setCargando] = useState(false);

  // ============================
  //        MODALES
  // ============================
  const [showCrear, setShowCrear] = useState(false);

  const [showVisualizar, setShowVisualizar] = useState(false);
  const [idVisualizar, setIdVisualizar] = useState(null);
  useEscClose(() => setShowVisualizar(false), showVisualizar);

  const [showEditar, setShowEditar] = useState(false);
  const [idEditar, setIdEditar] = useState(null);
  useEscClose(() => setShowEditar(false), showEditar);

  const [showEliminar, setShowEliminar] = useState(false);
  const [idEliminar, setIdEliminar] = useState(null);
  useEscClose(() => setShowEliminar(false), showEliminar);

  // ============================
  //        FILTROS
  // ============================
  const [filtros, setFiltros] = useState({});
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  useEscClose(() => setMostrarFiltros(false), mostrarFiltros);

  const limpiarSeleccion = () => {
    const empty = {};
    setFiltros(empty);
    setPaginaActual(1);
    fetchDescuentos(0, porPagina, empty);
  };

  // ============================
  //        FETCH
  // ============================
  const fetchDescuentos = async (
    pageIndex = paginaActual - 1,
    size = porPagina,
    filtrosAplicados = filtros
  ) => {
    setCargando(true);
    try {
      const url = apiRoutes.descuentoFlota.listUrl({
        page: pageIndex,
        size,
        ...filtrosAplicados,
      });

      const data = await appFetchJson(url);
      setItems(data?.items || []);
      setTotalBackend(data?.totalElements ?? 0);
    } catch (err) {
      console.error("Error al cargar descuentos flota:", err);
      setItems([]);
      setTotalBackend(0);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchDescuentos(0, porPagina, filtros);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ============================
  //        PAGINACIÓN
  // ============================
  const totalPaginas = Math.max(
    1,
    Math.ceil((totalBackend || 0) / (porPagina || 1))
  );

  const cambiarPagina = (num) => {
    const pagina = Math.min(Math.max(num, 1), totalPaginas);
    setPaginaActual(pagina);
    fetchDescuentos(pagina - 1, porPagina, filtros);
  };

  // ============================
  //        RENDER
  // ============================
  return (
    <div className="page">
      <ListHeader
        title="Descuento Flota"
        onFilterClick={() => setMostrarFiltros(true)}
        filters={filtros}
        onClearFilters={limpiarSeleccion}
        showAdd
        addLabel="Crear descuento"
        onAddClick={() => setShowCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPaginaActual(1);
          fetchDescuentos(0, size, filtros);
        }}
      />

      {mostrarFiltros && (
        <FiltroDescuento
          initialFilters={filtros}
          onSubmit={(nuevosFiltros) => {
            setFiltros(nuevosFiltros);
            setPaginaActual(1);
            setMostrarFiltros(false);
            fetchDescuentos(0, porPagina, nuevosFiltros);
          }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      {showCrear && (
        <CrearDescuentoFlota
          onClose={() => setShowCrear(false)}
          onSaved={() => {
            setShowCrear(false);
            fetchDescuentos(0, porPagina, filtros);
          }}
        />
      )}

      {showVisualizar && idVisualizar && (
        <VerDescuentoFlota
          id={idVisualizar}
          onClose={() => {
            setShowVisualizar(false);
            setIdVisualizar(null);
          }}
        />
      )}

      {showEditar && idEditar && (
        <EditarDescuentoFlota
          id={idEditar}
          onClose={() => {
            setShowEditar(false);
            setIdEditar(null);
          }}
          onSaved={() => {
            setShowEditar(false);
            setIdEditar(null);
            fetchDescuentos(0, porPagina, filtros);
          }}
        />
      )}

      {showEliminar && idEliminar && (
        <EliminarDescuentoFlota
          id={idEliminar}
          onVolver={() => {
            setShowEliminar(false);
            setIdEliminar(null);
          }}
          onEliminado={() => {
            setShowEliminar(false);
            setIdEliminar(null);
            fetchDescuentos(0, porPagina, filtros);
          }}
        />
      )}

      {/* TABLA */}
      <div className="overflow-x-auto mt-4">
        <table className="table-card table-sm">
          <thead className="table-head">
            <tr>
              <th className="cell text-left">Cliente</th>
              <th className="cell text-left">EE.SS.</th>
              <th className="cell text-left">Producto</th>
              <th className="cell text-left">Tarjeta</th>
              <th className="cell text-left">Fecha Inicio</th>
              <th className="cell text-left">Fecha Fin</th>
              <th className="cell-center">Acción</th>
            </tr>
          </thead>

          <tbody>
            {cargando ? (
              <tr>
                <td colSpan={7} className="cell text-center">Cargando…</td>
              </tr>
            ) : items.length === 0 ? (
              <tr>
                <td colSpan={7} className="cell text-center">Sin resultados</td>
              </tr>
            ) : (
              items.map((row, i) => (
                <tr key={row.id} className={i % 2 === 0 ? "row-alt" : ""}>
                  <td className="cell">{row.clienteNombre}</td>
                  <td className="cell">{row.eessNombre ?? "TODAS"}</td>
                  <td className="cell">{row.productoNombre ?? "TODOS"}</td>
                  <td className="cell">{row.tarjetaNumero ?? "TODAS"}</td>
                  <td className="cell">{row.fechaInicio}</td>
                  <td className="cell">{row.fechaFin}</td>
                  <td className="cell-center space-x-2">
                    <button
                      className="icon-btn"
                      title="Visualizar"
                      onClick={() => {
                        setIdVisualizar(row.id);
                        setShowVisualizar(true);
                      }}
                    >
                      <FaEye />
                    </button>
                    <button
                      className="icon-btn"
                      title="Editar"
                      onClick={() => {
                        setIdEditar(row.id);
                        setShowEditar(true);
                      }}
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="icon-btn text-red-600"
                      title="Eliminar"
                      onClick={() => {
                        setIdEliminar(row.id);
                        setShowEliminar(true);
                      }}
                    >
                      <FaTrashAlt />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ListFooter
        page={paginaActual}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={cambiarPagina}
      />
    </div>
  );
}
